module.exports = __webpack_public_path__ + "0f4ceb302221e4391831ed621d869ce1.svg";